// Fusión MANUAL de dos líneas sugeridas en Bandeja IA (la IA a veces divide una misma fila/espacio).
// Nunca se ejecuta automáticamente: el usuario elige las 2 líneas, revisa y confirma.

const ORDEN_TIPOS = ["diseno", "produccion", "envio", "montaje", "desmontaje", "retirada", "otros"];

const distinto = (a, b) => (a || "") !== (b || "") && a && b;

// Detecta conflictos que requieren decisión humana (espacio / fecha distintos y ambos informados).
export function conflictosFusion(a, b) {
  const out = [];
  if (distinto(a.espacio_id, b.espacio_id)) {
    out.push({ campo: "espacio_id", label: "Espacio", a: a._espacio_nombre_actual || a._espacio_sugerido_nombre || a.espacio_id, b: b._espacio_nombre_actual || b._espacio_sugerido_nombre || b.espacio_id });
  }
  if (distinto(a.fecha_programada, b.fecha_programada)) {
    out.push({ campo: "fecha_programada", label: "Fecha", a: a.fecha_programada, b: b.fecha_programada });
  }
  return out;
}

// Vista previa de la línea resultante. `elecciones` = { espacio_id: "a"|"b", fecha_programada: "a"|"b" } para los conflictos.
export function fusionarLineas(a, b, elecciones = {}) {
  const pick = (campo) => {
    const va = a[campo], vb = b[campo];
    if (!va) return vb;
    if (!vb) return va;
    if (va === vb) return va;
    return (elecciones[campo] || "a") === "b" ? vb : va;
  };
  const tipos = ORDEN_TIPOS.filter((t) => (a.tipos || []).includes(t) || (b.tipos || []).includes(t));
  const desc = [a.descripcion, b.descripcion].filter(Boolean);
  const descripcion = desc.length === 2 && desc[0] !== desc[1] ? `${desc[0]} + ${desc[1]}` : (desc[0] || "");
  const ref = [a.referencia_cliente, b.referencia_cliente].filter(Boolean);
  const avisos = Array.from(new Set([...(a._avisos || []), ...(b._avisos || [])]));
  const espacioSrc = pick("espacio_id") === b.espacio_id && b.espacio_id ? b : a;
  return {
    ...a,
    espacio_id: pick("espacio_id") || "",
    fecha_programada: pick("fecha_programada") || "",
    _espacio_sugerido_nombre: espacioSrc._espacio_sugerido_nombre,
    _espacio_candidatos: espacioSrc._espacio_candidatos || [],
    _espacio_idx: espacioSrc._espacio_idx,
    tipos: tipos.length ? tipos : ["montaje"],
    descripcion,
    referencia_cliente: ref.length === 2 && ref[0] !== ref[1] ? `${ref[0]} / ${ref[1]}` : (ref[0] || ""),
    seccion: a.seccion || b.seccion || "",
    firma: a.firma === b.firma ? a.firma : [a.firma, b.firma].filter(Boolean).join(" / "),
    componentes: [...(a.componentes || []), ...(b.componentes || [])].map((c) => ({ ...c })),
    _avisos: avisos,
    _fusionada: true,
  };
}

// Aplica la fusión sobre la lista: sustituye la línea i por la fusionada y elimina la j.
export function aplicarFusion(lineas, i, j, elecciones) {
  if (i === j || lineas[i] == null || lineas[j] == null) return lineas;
  const fusion = fusionarLineas(lineas[i], lineas[j], elecciones);
  return lineas.filter((_, k) => k !== j).map((ln, k) => (k === (i > j ? i - 1 : i) ? fusion : ln));
}
